<template>
  <UpdateSave
      :maxWidth="500"
      itemKey="IndexGroup"
      :fetchData="fetchData"
      :setTitle="setTitle"
      :setItemForm="setItemForm"
      :updateData="updateData"
      @onUpdate="(response) => $emit('onUpdate', response)"
      v-bind="$attrs"
  >
    <template
        v-slot:default="{
          errors,
          ItemForm
        }"
    >
      <v-row>
        <v-col
            cols="12"
            lg="9"
        >
          <v-text-field
              v-model="ItemForm.title"
              :error-messages="errors.title"
              :filled="true"
              :dense="true"
              hide-details="auto"
              label="Názov"
          />
        </v-col>

        <v-col
            cols="12"
            lg="3"
        >
          <v-text-field
              v-model="ItemForm.sort"
              :error-messages="errors.sort"
              :filled="true"
              :dense="true"
              hide-details="auto"
              label="Poradie"
              type="number"
          />
        </v-col>

        <v-col
            cols="12"
        >
          <v-text-field
              v-model="ItemForm.module"
              :error-messages="errors.module"
              :filled="true"
              :dense="true"
              hide-details="auto"
              label="Modul"
          />
        </v-col>
      </v-row>
    </template>
  </UpdateSave>
</template>

<script>
  import IndexGroups from '@/services/index-groups'

  import UpdateSave from '@/components/_Part/_Modal/_Save/Update'

  export default {
    name: 'Update',
    props: [
      'id'
    ],
    emits: [
      'onUpdate'
    ],
    components: {
      UpdateSave
    },
    methods: {
      fetchData() {
        return IndexGroups
          .read({
            id: this.id
          })
      },
      setTitle(Item) {
        return 'Upraviť skupinu číselníkov "' + Item.title + '"'
      },
      setItemForm(Item) {
        return {
          title: Item.title,
          sort: Item.sort,
          module: Item.module
        }
      },
      updateData(ItemForm) {
        return IndexGroups
          .update({
            id: this.id,
            data: ItemForm
          })
      }
    }
  }
</script>
